// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function carrousel() {

    var self = this,
        $cache = {};

    /**
     * Init Slider
     */
    function initSliders() {
      $cache.slider.slick({
        arrows: false,
        slidesToShow: 3,
        infinite: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

      $cache.slickList = $cache.slider.find('.slick-list');

      $cache.main.addClass('loaded');
      
      if ($cache.slides.length == 1) $cache.nav.addClass('is-hidden');
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.html = $('html');
      $cache.main = target;

      $cache.slider = $cache.main.find('.slider-slide-wrapper');
      $cache.slides = $cache.slider.find('.slide');

      $cache.nav = $cache.main.find('.slider-control');
      $cache.prev = $cache.nav.filter('.prev');
      $cache.next = $cache.nav.filter('.next');
    }

    /**
     * Register Events
     */
    function registerEvents() {
      $cache.slider.on('init', function(slick){
        window.cache.$window.trigger('resize');
      }).on('reInit', function(slick){
        window.cache.$window.trigger('resize');
      }).on('afterChange', function(slick){
        window.cache.$window.trigger('resize');
      });

      window.cache.$window.on('resize', function() {
        $cache.slickList = $cache.slider.find('.slick-list');
        $cache.slides = $cache.slider.find('.slide');

        setTimeout(function(){ 
          if(typeof $cache.slider.slick === 'function' && $cache.slickList !== undefined) {
            $cache.slickList.css('height', 'auto');
            $cache.slides.css('height', 'auto');

            var height = 0;
            $cache.slides.each(function(){
              var h = $(this).height();
              if(h > height) height = h;
            });

            $cache.slickList.height(height);
            $cache.slides.height(height);
          }
        }, 150);
      });

      $cache.prev.on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('is-disabled')) return;
        if(typeof $cache.slider.slick === 'function') $cache.slider.slick('slickPrev');
      });

      $cache.prev.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.prev.trigger('click');
        }
      });

      $cache.next.on('click', function(e){
        e.preventDefault();
        if($(this).hasClass('is-disabled')) return;
        if(typeof $cache.slider.slick === 'function') $cache.slider.slick('slickNext');
      });

      $cache.next.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.next.trigger('click');
        }
      });
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);
      registerEvents();

      initSliders();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.carrousel = carrousel;
  
}(jQuery));
